<script setup lang="ts">
import { computed, useSlots, withDefaults } from 'vue'
import { hasSlotContent } from '../../utils/hasSlotContent'

interface PropTypes {
  headerColor?: string
  footerColor?: string
  stickyHeader?: boolean
}

const props = withDefaults(defineProps<PropTypes>(), {
  headerColor: 'stone-300',
  footerColor: 'sky-900',
  stickyHeader: true,
})

const slots = useSlots()
const hasFooter = computed(() => hasSlotContent('footer-content', slots))
const getHeaderClassArr = computed(() => [`bg-${props.headerColor}`, { sticky: props.stickyHeader }, 'z-50'])
const getFooterClassArr = computed(() => [`bg-${props.footerColor}`])
</script>

<template>
  <div id="base-layout" class="h-full flex flex-col min-h-screen">
    <header :class="getHeaderClassArr">
      <slot name="header-content" />
    </header>
    <main id="page-content" class="grow shrink relative">
      <slot name="main-content" />
    </main>
    <footer v-if="hasFooter" :class="getFooterClassArr">
      <slot name="footer-content" />
    </footer>
  </div>
</template>

<style>
header {
  position: sticky;
  top: 0;
  z-index: 5;
}
#page-content {
  overflow: hidden;
}
</style>
